import { GlobusLogoLight } from 'img';
import React, { memo, ReactNode, useMemo } from 'react';
import styled from 'styled-components';

interface PredefinedIconProps {
    variant: 'info' | 'error';
    icon?: undefined;
}

interface CustomIconProps {
    variant: 'custom';
    icon: ReactNode;
}

export type StatusIconVariantProps = PredefinedIconProps | CustomIconProps;

type StatusIconProps = {
    className?: string;
} & StatusIconVariantProps;

function StatusIcon(props: StatusIconProps) {
    const { className } = props;

    const variant = props.variant;
    const iconProp = props.icon;

    const icon = useMemo(() => {
        if (variant === 'custom') {
            return iconProp;
        }

        return <GlobusLogo $variant={ variant } />;
    }, [ variant, iconProp ]);

    return (
        <Root className={ className }>
            { icon }
        </Root>
    );
}

const Root = styled.div`
    width: 40px;
    height: 46px;
`;

const GlobusLogo = styled(GlobusLogoLight)<{ $variant: 'error' | 'info' }>`
    display: block;
    width: 100%;
    height: 100%;

    path {
        ${ ({ $variant, theme }) => $variant === 'info' && `fill: ${ theme.color.rubin };` }
        ${ ({ $variant, theme }) => $variant === 'error' && `fill: ${ theme.color.grey.grey_20 };` }
    }
`;

export default memo(StatusIcon);
